module.exports = __webpack_public_path__ + "img/unlock.321248b5.svg";